import React, { useState } from 'react';
import Icon from '../../components/AppIcon';
import DocumentCapture from '../../components/ui/DocumentCapture';

const ACCENT = '#D6EF4E';

const MODULES = [
  { id: 'facturas-entrantes', label: 'Facturas Entrantes', icon: 'FileInput', color: '#60A5FA' },
  { id: 'facturas-salientes', label: 'Facturas Salientes', icon: 'FileOutput', color: '#34D399' },
  { id: 'compras', label: 'Compras', icon: 'ShoppingCart', color: '#FBBF24' },
  { id: 'gastos', label: 'Gastos', icon: 'Receipt', color: '#F97316' },
  { id: 'tesoreria', label: 'Tesorería', icon: 'Wallet', color: '#A78BFA' },
  { id: 'bancos', label: 'Bancos', icon: 'Landmark', color: '#60A5FA' },
  { id: 'proveedores', label: 'Proveedores', icon: 'Truck', color: '#34D399' },
];

const KPIS = [
  { label: 'Facturas Capturadas', value: '—', icon: 'Camera', color: ACCENT },
  { label: 'Pendientes Revisión', value: '—', icon: 'Clock', color: '#FBBF24' },
  { label: 'Validadas', value: '—', icon: 'CheckCircle', color: '#34D399' },
  { label: 'OCR Procesando', value: '—', icon: 'Cpu', color: '#60A5FA' },
];

const DOC_STATES = ['Capturada', 'OCR Procesando', 'Pendiente Revisión', 'Validada', 'Contabilizada', 'Pendiente Pago', 'Pagada', 'Archivada'];
const STATE_COLORS = {
  'Capturada': '#60A5FA', 'OCR Procesando': '#FBBF24', 'Pendiente Revisión': '#F97316',
  'Validada': '#34D399', 'Contabilizada': '#A78BFA', 'Pendiente Pago': '#F87171',
  'Pagada': '#34D399', 'Archivada': '#6B7280',
};

const AUDIT_LOG = [
  { user: 'Admin', date: '2026-07-23', time: '10:32', action: 'Captura de factura', detail: 'FAC-2026-0001 — Proveedor: —' },
  { user: 'Admin', date: '2026-07-23', time: '10:35', action: 'OCR completado', detail: 'FAC-2026-0001 — Datos extraídos' },
  { user: 'Admin', date: '2026-07-23', time: '10:40', action: 'Validación manual', detail: 'FAC-2026-0001 — Estado: Validada' },
];

export default function TiendaFinanzas() {
  const [activeModule, setActiveModule] = useState('facturas-entrantes');
  const [showCapture, setShowCapture] = useState(false);
  const [documents, setDocuments] = useState([]);
  const [search, setSearch] = useState('');
  const [stateFilter, setStateFilter] = useState('Todos');
  const [showAudit, setShowAudit] = useState(false);

  const activeModuleData = MODULES?.find(m => m?.id === activeModule);

  const handleSaveDocument = (data) => {
    const newDoc = {
      id: Date.now(),
      numero: data?.ocrData?.numero_factura || 'DOC-' + Date.now(),
      proveedor: data?.ocrData?.proveedor || '—',
      fecha: data?.ocrData?.fecha_factura || new Date()?.toISOString()?.split('T')?.[0],
      total: data?.ocrData?.total_factura || '—',
      estado: data?.docState,
      departamento: data?.ocrData?.departamento || '—',
      modulo: activeModule,
    };
    setDocuments(prev => [newDoc, ...prev]);
    setShowCapture(false);
  };

  const filteredDocs = documents?.filter(d => {
    const matchModule = d?.modulo === activeModule;
    const matchSearch = !search || d?.numero?.toLowerCase()?.includes(search?.toLowerCase()) || d?.proveedor?.toLowerCase()?.includes(search?.toLowerCase());
    const matchState = stateFilter === 'Todos' || d?.estado === stateFilter;
    return matchModule && matchSearch && matchState;
  });

  return (
    <div className="min-h-screen px-4 py-6 md:px-8" style={{ background: 'linear-gradient(135deg, #0A0A0A 0%, #111111 50%, #0D0D0D 100%)' }}>
      {/* Breadcrumb */}
      <div className="flex items-center gap-2 mb-5 font-oranienbaum text-white/30" style={{ fontSize: 'var(--fs-sm)' }}>
        <Icon name="Home" size={13} />
        <span>/</span>
        <span className="text-[#D6EF4E]/60">Tienda General</span>
        <span>/</span>
        <span className="text-white/50">Finanzas Tienda</span>
      </div>
      {/* Header */}
      <div className="flex flex-col md:flex-row md:items-center justify-between gap-4 mb-6">
        <div className="flex items-center gap-3">
          <div className="w-11 h-11 rounded-xl flex items-center justify-center flex-shrink-0"
            style={{ background: 'rgba(214,239,78,0.10)', border: '1px solid rgba(214,239,78,0.25)' }}>
            <Icon name="Landmark" size={22} className="text-[#D6EF4E]" />
          </div>
          <div>
            <h1 className="font-oranienbaum font-bold text-white tracking-wide" style={{ fontSize: 'var(--fs-page-title)' }}>Finanzas Tienda</h1>
            <p className="font-oranienbaum text-white/40" style={{ fontSize: 'var(--fs-sm)' }}>Captura inteligente · OCR · Gestión documental</p>
          </div>
        </div>
        <div className="flex items-center gap-2">
          <button onClick={() => setShowAudit(!showAudit)}
            className="flex items-center gap-2 px-4 py-2.5 rounded-xl font-oranienbaum border transition-all"
            style={{ background: 'rgba(255,255,255,0.04)', border: '1px solid rgba(255,255,255,0.10)', color: 'rgba(255,255,255,0.6)', fontSize: 'var(--fs-btn)' }}>
            <Icon name="History" size={15} /> Auditoría
          </button>
          <button onClick={() => setShowCapture(true)}
            className="flex items-center gap-2 px-5 py-2.5 rounded-xl font-oranienbaum font-bold transition-all hover:opacity-90"
            style={{ background: ACCENT, color: '#000', fontSize: 'var(--fs-btn)' }}>
            <Icon name="Camera" size={16} /> 📷 Hacer Foto
          </button>
        </div>
      </div>
      {/* KPIs */}
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 mb-6">
        {KPIS?.map((kpi, i) => (
          <div key={i} className="rounded-2xl p-5 flex flex-col gap-3" style={{ background: 'rgba(255,255,255,0.03)', border: '1px solid rgba(255,255,255,0.07)', minHeight: '130px' }}>
            <div className="flex items-center justify-between">
              <div className="w-9 h-9 rounded-xl flex items-center justify-center" style={{ background: `${kpi?.color}15`, border: `1px solid ${kpi?.color}30` }}>
                <Icon name={kpi?.icon} size={17} style={{ color: kpi?.color }} />
              </div>
            </div>
            <div>
              <p className="font-oranienbaum font-bold text-white" style={{ fontSize: 'var(--fs-kpi-value)' }}>{kpi?.value}</p>
              <p className="font-oranienbaum text-white/45 mt-0.5" style={{ fontSize: 'var(--fs-kpi-label)' }}>{kpi?.label}</p>
            </div>
          </div>
        ))}
      </div>
      {/* Module tabs */}
      <div className="flex flex-wrap gap-2 mb-6">
        {MODULES?.map(mod => (
          <button key={mod?.id} onClick={() => setActiveModule(mod?.id)}
            className="flex items-center gap-2 px-4 py-2.5 rounded-xl font-oranienbaum transition-all"
            style={{
              background: activeModule === mod?.id ? `${mod?.color}15` : 'rgba(255,255,255,0.04)',
              border: `1px solid ${activeModule === mod?.id ? `${mod?.color}35` : 'rgba(255,255,255,0.08)'}`,
              color: activeModule === mod?.id ? mod?.color : 'rgba(255,255,255,0.55)',
              fontSize: 'var(--fs-sm)',
              fontWeight: activeModule === mod?.id ? 600 : 400,
            }}>
            <Icon name={mod?.icon} size={14} />
            {mod?.label}
          </button>
        ))}
      </div>
      {/* Module content */}
      <div className="rounded-2xl overflow-hidden" style={{ background: 'rgba(255,255,255,0.02)', border: '1px solid rgba(255,255,255,0.07)' }}>
        {/* Module header */}
        <div className="flex items-center justify-between px-5 py-4 border-b" style={{ borderColor: 'rgba(255,255,255,0.06)' }}>
          <div className="flex items-center gap-3">
            <div className="w-8 h-8 rounded-lg flex items-center justify-center" style={{ background: `${activeModuleData?.color}15`, border: `1px solid ${activeModuleData?.color}30` }}>
              <Icon name={activeModuleData?.icon} size={15} style={{ color: activeModuleData?.color }} />
            </div>
            <h2 className="font-oranienbaum font-bold text-white" style={{ fontSize: 'var(--fs-section-title)' }}>{activeModuleData?.label}</h2>
          </div>
          <button onClick={() => setShowCapture(true)}
            className="flex items-center gap-2 px-4 py-2 rounded-xl font-oranienbaum font-bold transition-all hover:opacity-90"
            style={{ background: ACCENT, color: '#000', fontSize: 'var(--fs-sm)' }}>
            <Icon name="Camera" size={14} /> 📷 Hacer Foto
          </button>
        </div>

        {/* Filters */}
        <div className="flex flex-wrap items-center gap-3 px-5 py-3 border-b" style={{ borderColor: 'rgba(255,255,255,0.05)' }}>
          <div className="flex items-center gap-2 flex-1 min-w-[200px] rounded-xl px-3 border" style={{ background: 'rgba(255,255,255,0.04)', borderColor: 'rgba(255,255,255,0.10)', minHeight: 'var(--control-height-sm)' }}>
            <Icon name="Search" size={14} className="text-white/35" />
            <input value={search} onChange={e => setSearch(e?.target?.value)} placeholder="Buscar por número, proveedor..."
              className="flex-1 bg-transparent outline-none font-oranienbaum text-white placeholder-white/25"
              style={{ fontSize: 'var(--fs-base)' }} />
          </div>
          <select value={stateFilter} onChange={e => setStateFilter(e?.target?.value)}
            className="font-oranienbaum rounded-xl px-3 border outline-none text-white"
            style={{ background: '#0D0D0D', borderColor: 'rgba(255,255,255,0.10)', minHeight: 'var(--control-height-sm)', fontSize: 'var(--fs-base)' }}>
            <option value="Todos">Todos los estados</option>
            {DOC_STATES?.map(s => <option key={s} value={s}>{s}</option>)}
          </select>
        </div>

        {/* Table */}
        <div className="overflow-x-auto">
          {filteredDocs?.length === 0 ? (
            <div className="flex flex-col items-center justify-center py-16 gap-4">
              <div className="w-14 h-14 rounded-2xl flex items-center justify-center" style={{ background: 'rgba(214,239,78,0.06)', border: '1px solid rgba(214,239,78,0.15)' }}>
                <Icon name="Camera" size={24} className="text-[#D6EF4E]/50" />
              </div>
              <div className="text-center">
                <p className="font-oranienbaum font-bold text-white/60" style={{ fontSize: 'var(--fs-lg)' }}>Sin documentos capturados</p>
                <p className="font-oranienbaum text-white/30 mt-1" style={{ fontSize: 'var(--fs-sm)' }}>Usa el botón "📷 Hacer Foto" para capturar tu primer documento</p>
              </div>
              <button onClick={() => setShowCapture(true)}
                className="flex items-center gap-2 px-5 py-2.5 rounded-xl font-oranienbaum font-bold transition-all"
                style={{ background: ACCENT, color: '#000', fontSize: 'var(--fs-btn)' }}>
                <Icon name="Camera" size={15} /> 📷 Hacer Foto
              </button>
            </div>
          ) : (
            <table className="w-full font-oranienbaum">
              <thead>
                <tr style={{ borderBottom: '1px solid rgba(255,255,255,0.07)' }}>
                  {['Número', 'Proveedor', 'Fecha', 'Total', 'Departamento', 'Estado', 'Acciones']?.map(h => (
                    <th key={h} className="text-left px-4 py-3 text-white/40 font-medium" style={{ fontSize: 'var(--fs-table-header)' }}>{h}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {filteredDocs?.map(doc => (
                  <tr key={doc?.id} className="hover:bg-white/3 transition-colors" style={{ borderBottom: '1px solid rgba(255,255,255,0.04)', minHeight: 'var(--table-row-height)' }}>
                    <td className="px-4 py-3 text-white font-medium" style={{ fontSize: 'var(--fs-table-row)' }}>{doc?.numero}</td>
                    <td className="px-4 py-3 text-white/70" style={{ fontSize: 'var(--fs-table-row)' }}>{doc?.proveedor}</td>
                    <td className="px-4 py-3 text-white/60" style={{ fontSize: 'var(--fs-table-row)' }}>{doc?.fecha}</td>
                    <td className="px-4 py-3 text-white font-bold" style={{ fontSize: 'var(--fs-table-row)' }}>{doc?.total !== '—' ? `${doc?.total} €` : '—'}</td>
                    <td className="px-4 py-3 text-white/60" style={{ fontSize: 'var(--fs-table-row)' }}>{doc?.departamento}</td>
                    <td className="px-4 py-3">
                      <span className="px-2.5 py-1 rounded-full font-medium" style={{ background: `${STATE_COLORS?.[doc?.estado] || '#fff'}15`, color: STATE_COLORS?.[doc?.estado] || '#fff', fontSize: 'var(--fs-badge)' }}>
                        {doc?.estado}
                      </span>
                    </td>
                    <td className="px-4 py-3">
                      <div className="flex items-center gap-1">
                        <button className="w-8 h-8 rounded-lg flex items-center justify-center text-white/35 hover:text-white hover:bg-white/8 transition-all">
                          <Icon name="Eye" size={15} />
                        </button>
                        <button className="w-8 h-8 rounded-lg flex items-center justify-center text-white/35 hover:text-white hover:bg-white/8 transition-all">
                          <Icon name="Edit2" size={15} />
                        </button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      </div>
      {/* Audit panel */}
      {showAudit && (
        <div className="mt-6 rounded-2xl overflow-hidden" style={{ background: 'rgba(255,255,255,0.02)', border: '1px solid rgba(255,255,255,0.07)' }}>
          <div className="flex items-center justify-between px-5 py-4 border-b" style={{ borderColor: 'rgba(255,255,255,0.06)' }}>
            <div className="flex items-center gap-2">
              <Icon name="History" size={16} className="text-[#D6EF4E]" />
              <h3 className="font-oranienbaum font-bold text-white" style={{ fontSize: 'var(--fs-section-title)' }}>Historial de Auditoría</h3>
            </div>
            <button onClick={() => setShowAudit(false)} className="text-white/35 hover:text-white transition-colors">
              <Icon name="X" size={15} />
            </button>
          </div>
          <div className="divide-y" style={{ divideColor: 'rgba(255,255,255,0.04)' }}>
            {AUDIT_LOG?.map((log, i) => (
              <div key={i} className="flex items-start gap-4 px-5 py-3">
                <div className="w-8 h-8 rounded-full flex items-center justify-center flex-shrink-0 font-oranienbaum font-bold text-xs" style={{ background: 'rgba(214,239,78,0.12)', color: ACCENT }}>
                  {log?.user?.charAt(0)}
                </div>
                <div className="flex-1">
                  <div className="flex items-center gap-2">
                    <span className="font-oranienbaum font-bold text-white" style={{ fontSize: 'var(--fs-sm)' }}>{log?.action}</span>
                    <span className="font-oranienbaum text-white/30" style={{ fontSize: 'var(--fs-xs)' }}>{log?.date} {log?.time}</span>
                  </div>
                  <p className="font-oranienbaum text-white/45 mt-0.5" style={{ fontSize: 'var(--fs-xs)' }}>{log?.detail}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}
      {/* Document Capture Modal */}
      {showCapture && (
        <DocumentCapture
          moduleLabel={activeModuleData?.label || 'Documento'}
          accentColor={ACCENT}
          onSave={handleSaveDocument}
          onClose={() => setShowCapture(false)}
        />
      )}
    </div>
  );
}
